// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__nVOjH","myModalContent":"MyModal_myModalContent__oHawp","active":"MyModal_active__OVq9I"};